import 'date-fns';
import React, { useState } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardTimePicker,
} from '@material-ui/pickers';

function DateAndTimePicker(props) {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState(new Date());

  const handleDateChange = (date) => {
    setSelectedDate(date);
    props.setDate(date);
  };

  const handleTimeChange = (time) => {
    setSelectedTime(time);
    props.setTime(time);
  }

  return (
    <div>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          id="time-picker"
          label="Date"
          format="MM/dd/yyyy"
          value={selectedDate}
          onChange={handleDateChange}
          disablePast
        />
        <KeyboardTimePicker
          id="time-picker"
          label="Time (EST)"
          value={selectedTime}
          onChange={handleTimeChange}
          disablePast
        />
      </MuiPickersUtilsProvider>
    </div>
  );
}

export default DateAndTimePicker;
